import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AvailableSites from '../Modals/AvailableSites';
import { IStudyItem } from '../types';

interface IProps {
  eprOptions: IStudyItem[];
}

const QuickLinks: React.FC<IProps> = ({ eprOptions }) => {
  const [isAvailableSitesOpen, setIsAvailableSitesOpen] = useState(false);

  return (
    <>
      <AvailableSites
        open={isAvailableSitesOpen}
        onClose={() => setIsAvailableSitesOpen(false)}
        eprOptions={eprOptions}
      />
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'grey.400',
          borderRadius: 0,
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          bgcolor: 'background.paper',
          flexShrink: 0,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
          Quick Links
        </Typography>
        <Button variant="contained" onClick={() => setIsAvailableSitesOpen(true)}>
          View Available Sites
        </Button>
      </Box>
    </>
  );
};

export default QuickLinks;
